var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[(_vm.itemData.isExtra)?_c('span',[_c('v-icon',{attrs:{"color":"yellow darken-2","left":""}},[_vm._v("mdi-star")]),_vm._v(_vm._s(_vm.itemData.boardBasis)+" ("+_vm._s(_vm.itemData.serviceName)+")\n  ")],1):_c('span',[_vm._v(_vm._s(_vm.itemData.serviceName))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-973ef380","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/shared/labels/ServiceNameLabel.vue
// module id = null
// module chunks = 